const Backofficebff: string = import.meta.env.VITE_BACKOFFICEBFF!;

export const BatchOutputQueryURL = {
    GetItems: Backofficebff + '/v1/batch-output/items',
    GetRejectReasons: Backofficebff + '/v1/batch-output/reject-reasons',
};
